import { render, staticRenderFns } from "./PerformanceObjectives.vue?vue&type=template&id=9c3051a4&scoped=true"
import script from "./PerformanceObjectives.vue?vue&type=script&lang=js"
export * from "./PerformanceObjectives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3051a4",
  null
  
)

export default component.exports